<template>
  <div id="qqLogin">
    <div class="box"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
    };
  },
  created() {
    //
  },
  methods: {
    //
  }
};
</script>
<style lang="scss">
#qqLogin {
}
</style>